<template>

  <input
          class="survey-input-xs"
          v-model="inputVal"
          type="number"
  />


</template>

<script>

  export default {
    props: ["value","label"],
    computed: {
      inputVal: {
        get() {
          return this.value;
        },
        set(val) {
          this.$emit('input', val);
        }
      }
    }
  };
</script>

<style>

</style>
